import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from "react-select";
import { RootState } from '../../../store';
import { IRegister } from './IRegister';
import countryCodes from "country-codes-list";
import useAuth from '../../../hooks/useAuth';
import utilValidations from '../../../common/utils/utilValidations';
import { useTranslateText } from '../../../hooks/userLanguageTranslate';
import UserHelper from '../../../common/utils/userHelper';
import ConfirmRegistration from '../../Auth/confirmRegistration';
import { useNavigate } from 'react-router-dom';
import { highlightTitle } from '../../../utils/htmlHelper';


interface AboutProps {
    landingPageData: any; 
          
  }
 
const Register:React.FC <AboutProps> = ({landingPageData}) => {

    const eventData = useSelector((state: RootState) => state.eventData);
    const text = landingPageData?.registeration_text || '';
    const eventTitle = eventData?.title || '';

    const [formData, setFormData] = useState<IRegister>({
    salutation: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    company_name: "",
    job_title: "",
    Phone: "",
    username: "",
    user_keywords: "",
    acceptance: "false",
    events: [{ event_id: `${eventData._id}`, role: "Attendee", status: true }],
    heard_about_us: "",
  });

    const user_keywords = eventData?.keywords || [];
    console.log(eventData)
    const [selectedOptions, setSelectedOptions] = useState([]);
    const handleChangeMM = (selected: any) => {
      const selectedValues = selected.map((opt: any) => opt); // Directly map to selected values
      const keywordsString = selectedValues.join(", ");
      setSelectedOptions(selectedValues);
      setFormData((prev) => ({
        ...prev,
        user_keywords: keywordsString, // Update matchmaking with the array
      }));
    };

  const codes: Record<string, string> = countryCodes.customList(
    "countryNameEn",
    "{countryCode}##(+{countryCallingCode})"
  );
  const sortedCodes: string[] = Object.keys(codes).sort();
  sortedCodes.pop();

  const { signUp } = useAuth();
  const { parseServerErrorResponse, formValidateField } = utilValidations();

  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [successMessage, setSuccessMessage] = useState<string>();
  const [fieldErrors, setFieldErrors] = useState<{
    [key: string]: string | null;
  }>({});
  const [isRegistered, setIsRegistered] = useState(false); // Track registration state
  let navigate = useNavigate();

  const translateText = useTranslateText;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? (checked ? "true" : "false") : value;
  
    
    if (name === "email") {
      formData.username = value;
    }
  
    const error = formValidateField(name, fieldValue);
    setFieldErrors((prev) => ({
      ...prev,
      [name]: error ?? null,
    }));
  
    setFormData({ ...formData, [name]: fieldValue }); // important: use fieldValue
  };

    const validateForm = (): boolean => {
      const newErrors: { [key: string]: string | null } = {};

      Object.keys(formData).forEach((key) => {
        const error = formValidateField(
          key,
          formData[key as keyof IRegister] as string
        );
        if (error) {
          newErrors[key] = error;
          console.log(newErrors);
        }
      });

      setFieldErrors(newErrors); // Update field errors for the entire form
      return Object.keys(newErrors).length === 0; // Form is valid if no errors
    };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessages([]); // Clear previous errors
    try {
      if (!validateForm()) {
        console.log("Client-side validation failed:", fieldErrors);
        // setErrorMessages(fieldErrors);
        return;
      }
      
      console.log(formData);
      const { acceptance, ...payload } = formData;
      const response = await signUp(payload);
      console.log("Registration successful:", response);
      const message = response.data?.data?.message;
      console.log("message",message)
      if (message?.includes("already exists")) {
        // Existing user enrolled in event
        setSuccessMessage(message); // Optional state to show message
      } else {
        // New user registered successfully
        setIsRegistered(true); // Update state
        navigate("/success");
      }

     // setIsRegistered(true); // Update state on success
    //  navigate("/success");
    } catch (error: any) {
      setIsRegistered(false);
      console.log("Error", error);

      if (error.response) {
        const errors = parseServerErrorResponse(error.response.data);
        setErrorMessages(errors);
        return errors;
      } else {
        setErrorMessages(["Something went wrong. Please try again later."]);
      }
    }
  };
  
  return isRegistered ? (
    <div className="single-section register-area">
      
    </div>
  ) : (
    // <!--Register section -->
    <div className="single-section register-area" id="register">
      <div className="container">
        <div className="row">

          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="section-heading">
              <h2 className="section-title" style={{
   '--before-bg': eventData.primary_color
  }}>Secure your seats</h2>

              <p className="section-description">
                 {highlightTitle(text, eventTitle)}
              </p>

             
            </div>
          </div>

          {!isRegistered?
            (<div className="col-lg-12 col-md-12 col-sm-12">
            <div className="contact-form">
              <form method="post" id="validation" className="form-area" noValidate>
                <div className="row">
                  {successMessage && (
                  <div className="success-message">
                  {successMessage}
                  </div>
                  )}
                  {errorMessages.length > 0 && (
                  <div className="error-messages">
                  {errorMessages.map((error, index) => (
                  <p key={index} className="error">
                  {UserHelper.convertToPlain(error)}
                  </p>
                  ))}
                  </div>
                  )}
                  <div className="col-md-6">
                        <label htmlFor="UserGender" className="d-block" style={{ marginBottom: '0px' }}>
                          {translateText("register-form-salutation","Salutation")}
                        </label>
                        <select
                          name="salutation"
                          onChange={handleChange}
                          required
                          className="form-control"
                        >
                          <option disabled hidden>
                            {" "}
                          </option>
                          <option value="-">-</option>
                          <option value="Mr">
                            {translateText("salutation-mr", "Mr.")}
                          </option>
                          <option value="Mrs">
                            {translateText("salutation-mrs", "Ms./Mrs.")}
                          </option>
                        </select>
                        {fieldErrors.salutation && (
                          <div className="alert alert-danger">
                            {fieldErrors.salutation}
                          </div>
                        )}
                  </div>
                  
                  {/* First Name */}
                  <div className="col-md-6 pt-25">
                    <div className="input-area">
                      <input
                          type="text" maxLength={50} name="first_name" 
                           onChange={handleChange} 
                           required autoComplete="off"
                        />
                    <label className="floating-label">
                        {translateText("register-form-first-name","First Name")}
                    </label>
                      {fieldErrors.first_name && (
                          <div className="alert alert-danger">
                            {fieldErrors.first_name}
                          </div>
                        )}
                      
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6 pt-25">
                    <div className="input-area">
                      <input
                          type="text" maxLength={50} name="last_name" 
                           onChange={handleChange} 
                           required autoComplete="off"
                        />
                    <label className="floating-label">
                        {translateText("register-form-last-name","Last Name")}
                    </label>
                      {fieldErrors.last_name && (
                          <div className="alert alert-danger">
                            {fieldErrors.last_name}
                          </div>
                        )}
                      
                    </div>
                  </div>
                  
                  {/* Company Name */}
                  <div className="col-md-6 pt-25">
                    <div className="input-area">
                      <input
                          type="text" maxLength={100} name="company_name" 
                           onChange={handleChange} 
                           required autoComplete="off"
                        />
                    <label className="floating-label">
                          {translateText("register-form-company-name","Company Name")}
                    </label>
                      {fieldErrors.company_name && (
                          <div className="alert alert-danger">
                            {fieldErrors.company_name}
                          </div>
                        )}
                      
                    </div>
                  </div>
                  
                  {/* Job Title */}
                  <div className="col-md-6 pt-25">
                    <div className="input-area">
                      <input
                          type="text" maxLength={100} name="job_title" 
                           onChange={handleChange} 
                           required autoComplete="off"
                        />
                    <label className="floating-label">
                          {translateText("register-form-job-title","Job Title")}
                    </label>
                      {fieldErrors.job_title && (
                          <div className="alert alert-danger">
                            {fieldErrors.job_title}
                          </div>
                        )}
                      
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-6 pt-25">
                    <div className="input-area">
                      <input  name="email" type="email" 
                      onChange={handleChange}
                      required autoComplete="off" />
                      <label className="floating-label">
                          {translateText("register-form-email","Email")}</label>
                      {fieldErrors.email && (
                          <div className="alert alert-danger">
                            {fieldErrors.email}
                          </div>
                        )}
                    </div>
                  </div>
                  
                  {/* Password */}
                  <div className="col-md-6 pt-25">
                    <div className="input-area">
                      <input  name="password" type="password" 
                      onChange={handleChange}
                      required autoComplete="off" />
                      <label className="floating-label">
                          {translateText('login-password',"Password")}
                          </label>
                      {fieldErrors.password && (
                          <div className="alert alert-danger">
                            {fieldErrors.password}
                          </div>
                        )}
                    </div>
                  </div>
                    
                  {/* Country Code */}
                  <div className="col-md-6 ">
                        <label htmlFor="CountryCode" className="d-block" style={{ marginBottom: '0px' }}>
                          {translateText("register-form-country-code","Country Code")}
                        </label>
                        <select
                          name="country_code"
                          onChange={handleChange}
                          className="form-control"
              
                        >
                          <option data-countryCode="" value="">
                            {translateText(
                              "register-form-select-location",
                              "Select Country Code"
                            )}
                          </option>
                          {fieldErrors.country_code && (
                            <div className="alert alert-danger">
                              {fieldErrors.country_code}
                            </div>
                          )}
                          {sortedCodes.map((key, index) => {
                            const splitedInfo = codes[key].split("##"); // Split country info
                            return (
                              <option
                                key={index} // Use `index` or a unique identifier from data
                                data-countryCode={splitedInfo[0]}
                                value={splitedInfo[0]}
                              >
                                {key} {splitedInfo[1]}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                  {/* Phone */}
                  <div className="col-md-6 pt-25">
                    <div className="input-area">
                      <input name="Phone" type="tel"
                       onChange={handleChange} 
                      required autoComplete="off" />
                      <label className="floating-label">
                          {translateText("register-form-phone-no","Phone No")}
                        </label>
                    </div>
                    {fieldErrors.Phone && (
                          <div className="alert alert-danger">
                            {fieldErrors.Phone}
                          </div>
                        )}
                  </div>

                    <div className="col-lg-6 comm">
                        <label htmlFor="match-making-keywords">
                          {translateText("label-match-making","Match Making")}                        </label>
                        <Select
                          isMulti
                          options={user_keywords.map((keyword: string) => ({
                            value: keyword,
                            label: keyword,
                          }))}
                          value={user_keywords
                            .filter((user_keywords: string) =>
                              selectedOptions.includes(user_keywords)
                            )
                            .map((keyword: string) => ({
                              value: keyword,
                              label: keyword,
                            }))}
                          onChange={(selected) =>
                            handleChangeMM(
                              selected.map((opt: any) => opt.value)
                            )
                          }
                          className="basic-multi-select"
                          classNamePrefix="select-keywords"
                        />
                        <input
                          type="hidden"
                          name="user_keywords"
                          value={JSON.stringify(selectedOptions)} // To verify the value
                        />
                      </div>


                      {/* How did you come across our platform? */}
                      {/* <div className="col-lg-6 comm pt-25">
                        <label htmlFor="heard_about_us">
                         How did you come across our platform?
                        </label>
                        <select
                          name="heard_about_us"
                          onChange={handleChange}
                          value={formData.heard_about_us}
                          className="form-control"
                          required
                        >
                          <option value="" disabled>
                            {translateText("register-form-select-option", "Select an option")}
                          </option>
                          <option value="LinkedIn">LinkedIn</option>
                          <option value="Google">Google</option>
                          <option value="Physical events">Physical events</option>
                          <option value="Other">Other</option>
                        </select>
                        {fieldErrors.heard_about_us && (
                          <div className="alert alert-danger">{fieldErrors.heard_about_us}</div>
                        )}
                      </div> */}


                  <div className="col-md-8 ">
                        
                         <div style={{marginTop:'28px'}}> 
                          <input
                          type="checkbox" required name="acceptance" aria-invalid="false" className="acceptance-btn" value="1"
                          onChange={handleChange}
                           />
                          {translateText("register-form-policy-text","I have read and agree to the")}
                          <a
                            href="https://www.avianetvep.com/privacy-policy/"
                            rel="noReferrer"
                            target="_blank"
                          >
                            {" "}
                            {translateText("register-form-policy-link-text"," privacy policy")}
                          </a>
                        </div>
                       

                        {fieldErrors.acceptance && (
                          <div className="alert alert-danger">
                            {fieldErrors.acceptance}
                          </div>
                        )}
                      </div>

                  <div className="col-md-4 text-right">
                    <button name="register" type="submit" className="btn" value="promo" id="paymentbtn" onClick={handleSubmit}
                    style={{color: eventData?.primary_text_color, backgroundColor: eventData.register_button_color}}>
                      {translateText("register-button","Register Now")}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>):
          (<div  className="col-lg-7 col-md-12 col-sm-12">
            <div className="contact-form"><h1>Thank You For Your Registration</h1></div>
            </div>
          )
          }

        </div>
      </div>
    </div>
  );
};

export default Register;
